import * as t from "react";
const e = /*#__PURE__*/ t.createContext(()=>"");
export { e as default };
